//Polyfills
import "core-js/stable";
import 'core-js/modules/es.promise';
import 'core-js/modules/es.string.includes';
import 'core-js/modules/es.object.assign';
import 'core-js/modules/es.object.keys';
import 'core-js/modules/es.symbol';
import 'core-js/modules/es.symbol.async-iterator';
import "regenerator-runtime/runtime";
//Axios
import * as es6Promise from 'es6-promise';
import 'isomorphic-fetch';
//Excel
import rewritePattern from 'regexpu-core';
import { generateRegexpuOptions } from '@babel/helper-create-regexp-features-plugin/lib/util';

const OriginalRegExp = globalThis.RegExp;
try {
  new OriginalRegExp('a', 'u');
} catch (err) {
  globalThis.RegExp = function (pattern, flags) {
    if (flags && flags.includes('u')) {
      return new OriginalRegExp(rewritePattern(pattern, flags, generateRegexpuOptions({ flags, pattern })));
    }
    return new OriginalRegExp(pattern, flags);
  };
  globalThis.RegExp.prototype = OriginalRegExp.prototype;
}
//Axios
es6Promise.polyfill();